import { initializeApp } from "firebase/app";
import {
    getAnalytics,
    isSupported,
    setAnalyticsCollectionEnabled,
} from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// 🔹 Firebase‑Konfiguration aus .env
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// 🔹 Firebase‑Dienste initialisieren (vor den Emulator‑Verbindungen)
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west3");

// 🔹 Emulator‑Verbindungen NUR im Development‑Modus
if (process.env.NODE_ENV === "development") {
    // Auth‑Emulator (Port 9099)
    connectAuthEmulator(auth, "http://localhost:9099", {
        disableWarnings: true, // unterdrückt die Warnung im Konsolen‐Log
    });

    // Firestore‑Emulator (Port 8080)
    connectFirestoreEmulator(db, "localhost", 8080);

    // Functions‑Emulator (Port 5001) – überschreibt die gesetzte Region
    connectFunctionsEmulator(functions, "localhost", 5001);

    console.log("🔌 Firebase Emulatoren verbunden (Auth, Firestore, Functions)");
}

// 🔹 Analytics mit Einwilligungssteuerung (unverändert)
let analyticsInstance: any = null;
let analyticsInitialized = false;

isSupported().then((yes) => {
    if (yes) {
        analyticsInstance = getAnalytics(app);
        analyticsInitialized = true;

        const consentKey = "studytino_cookie_consent";
        const stored = localStorage.getItem(consentKey);
        let enabled = false;
        if (stored) {
            try {
                enabled = JSON.parse(stored).analytics === true;
            } catch (e) {
                /* ignore */
            }
        }
        setAnalyticsCollectionEnabled(analyticsInstance, enabled);
        console.log(`📊 Analytics initialisiert, Sammlung aktiv: ${enabled}`);
    }
});

export const setAnalyticsEnabled = (enabled: boolean) => {
    if (analyticsInstance && analyticsInitialized) {
        setAnalyticsCollectionEnabled(analyticsInstance, enabled);
        console.log(`📊 Analytics‑Sammlung live geändert auf: ${enabled}`);
    } else {
        console.warn(
            "Analytics noch nicht initialisiert – Änderung wird beim Start berücksichtigt."
        );
    }
};

// 🔹 App‑Check (unverändert, aber im Dev‑Modus wird der Debug‑Token gesetzt)
if (process.env.NODE_ENV === "development") {
    const debugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;
    if (debugToken) {
        (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
    }
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY!),
        isTokenAutoRefreshEnabled: true,
    });
} else {
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY!),
        isTokenAutoRefreshEnabled: true,
    });
}

export default app;